/** @format */

import React from 'react';
import CustomShapeSelect from './custom_shape_select';
import useRequest from './hooks/use_request';
import SuperAgent from 'superagent';

export function PreviouslyUsedShapeSelect({selectedDie, onChange}) {
    const {data, isPending, error} = useRequest(
        [],
        async () => {
            const res = await SuperAgent.get('/account/sizes/my-custom-sizes').set(
                'accept',
                'application/json'
            );
            return res.body.existingCustomSizes;
        },
        {
            initial: []
        }
    );

    if (isPending) {
        return <p>Loading...</p>;
    }

    if (error) {
        return <p>{error.message}</p>;
    }

    return <CustomShapeSelect dies={data} selectedDie={selectedDie} onChange={onChange} />;
}
